import {
    IExpenseDocument, IObjectAudit, IPosition, ILocationDocument, IGeoLocation,
    IMicroLocationDocument, IScheduleShift, IJobStatus, IContactInfo,
    IHierarchyItemSettings, IOccupationInfo, ISpecialtyInfo, IPayTypeBudget, IBadgeInfo, IDate, IPositionTask, ELanguage
} from "../../../models"

export interface IJobDocument extends IGeoLocation {
    Id: string
    Name: string
    AccountId: string
    HierarchyId: string
    ClientId: string
    ClientName: string
    CostCode: string
    Deleted: boolean
    TicksSinceChange: number
    AssignedEmployees: IJobEmployee[]
    ContractPositions: IContractPosition[]
    ExpenseTemplates: IExpenseTemplate[]
    WorkPoolEmployees: IWorkPoolEmployee[]
    ObjectAudit: IObjectAudit
    Phases: IJobPhase[]
    HierarchyList: string[]
    SupervisorId: string
    ComplianceManagerId: string
    AccountManagerId: string
    PayrollManagerId: string
    Active: boolean
    PositionIds: string[]
    Positions: IPosition[]
    PerDiemShift: IScheduleShift
    ExternalId: string
    Note: string
    Type: string
    Status: IJobStatus
    ContactInfo: IContactInfo
    LinkedEmployeeIds: string[]
    UserModified: boolean
    HasStartEndDates: boolean
    StartDate: string
    EndDate: string
    StartDateLocal: IDate
    EndDateLocal: IDate
    RequiredOccupations: IOccupationInfo[]
    RequiredSpecialties: ISpecialtyInfo[]
    Badges: IBadgeInfo[]
    AutoAssignEmployees: boolean
    NumberOfShifts: number
    JobType: EJobType
    Field1: string
    Field2: string
    Field3: string
    Field4: string
    PayTypeBudgetItems: IPayTypeBudget[]
    IsFavorite: boolean
    HierarchyItemSettings: IHierarchyItemSettings
    Images: IJobImage[]
    ShowJobToMobileUsers: boolean
}

export interface IJobImage {
    Id: string
    ImageUrl: string
}

export interface IJobPhase {
    Id: string
    Name: string
    CostCode: string
    Active: boolean
    PositionIds: string[]
    Positions: IPosition[]
    IsLocation: boolean
    IsMicroLocation: boolean
    Location: ILocationDocument
    MicroLocation: IMicroLocationDocument
    Deleted: boolean
}

export interface IContractPosition {
    PositionTemplate: IPosition
    PayclassBudgets: IPayclassBudget[]
    JobEmployees: IJobEmployee[]
}

export interface IPayclassBudget {
    PositionId: string
    PayclassId: string
    OnTime: boolean
    WeeklyHours: number
    OneTimeHours: number
    GuranteedMinimum: boolean
    MinimumWeeklyHours: number
    MinimumOnetimeHours: number
}

export interface IJobEmployee {
    Id: string
    EmployeeName: string
    ExternalId: string
    ProfileImageS3Url: string
    DefaultJobId: string
    DefaultJob: string
    AssignedDate: string
    UnassignedDate: string
    Unassigned: boolean
    Position: IPosition
    PayclassBudget: IPayclassBudget
    Expenses: IExpenseTemplate[]
}

export interface IWorkPoolEmployee {
    Id: string
    EmployeeName: string
    Email: string
    HomePhoneNo: string
    MobilePhoneNo: string
    MissingBadgeNames: string[]
    MissingBadgeIds: string[]
    // -3: If job does not have a location, grid should show "No Job location"
    // -2: If the employee does not have an address in their HR profile is should show "No employee location"
    // -1: If both the employee and job do not have an address just show "Unknown"
    MilesFromClient: number
    Available: boolean
    SubmittedById: string
    SubmittedByName: string
    ArchivedByUserIds: string[]
    ShortlistedUserIds: string[]
    Suggested: boolean
    EmployeeRequested: boolean
    EmployeeRequestedAt: string | Date
    Declined: boolean
    DeclinedAt: string | Date
    DeclinedByUserId: string
    DeclinedByUserName: string
    DeclinedUserProfileImageUrl: string
    AutoMatched: boolean
    AutoMatchNote: string
    ObjectAudit: IObjectAudit
    Confirmed: boolean
    ConfirmedByUserId: string
    ConfirmedByUserName: string
    ConfirmedProfileImageS3Url: string
    ConfirmedAt: string | Date
    Withdrawn: boolean
    WithdrawnAt: string | Date
    Specialities:string[]
    Occupation:string
}

export interface WorkPoolEmployeeSearchParams {
    AccountId: string
    SearchTerm: string
    MatchSpecialty: boolean
    MatchOccupation: boolean
    Available: boolean
    MatchByDistanceToJob: boolean
    RadiusToJob: number
    DoNotMatchDoubleShift: boolean
    TimeRequiredBetweenShifts: number
    RequireBagdeMatch: boolean
    RequiresCompletedBadges: boolean
    EmployeeStatusIds: string[]
    EmployeeStatusFilters?: StatusFilterParam[];
    SpecialtyIds: string[]
    OccupationIds: string[]
    BadgeIds: string[]
    Page: number
    Limit: number
    ShowInactive: boolean
}

export interface StatusFilterParam {
    StatusId: string
    SubStatusId: string
}

export interface IExpenseTemplate {
    Id: string
    Expense: IExpenseDocument
    ExpenseScheduleType: EExpenseScheduleTypeEnum
}

export enum EExpenseScheduleTypeEnum {
    OneTime = 0,
    Weekly = 1,
    Daily = 2,
    Monthly = 3,
    Shift = 4
}

export enum EJobType {
    Contract = 0,
    NonContract = 1
}

export interface IWorkInstructions {
    Id: string
    PositionWorkInstructions: IPositionWorkInstructions[]
}

export interface IPositionWorkInstructions {
    Id: string
    PositionName: string
    BasePositionId: string
    WorkInstructionItems: IWorkInstructionItem[]
}

export interface IWorkInstructionItem {
    Id: string
    ItemName: string
    Descriptions: IWorkItemDescription[]
    Active: boolean
    ActiveByDefault: boolean
}

export interface IWorkItemDescription {
    Id: string
    Description: string
    Language: ELanguage
    ExternalUrl: string
    OptionalPunchTasks: IPositionTask[]
    RequiredPunchTasks: IPositionTask[]
}